import React, { useEffect, useState, useCallback, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { IoMdClose } from "react-icons/io";
import "./SubscribeModal.css";
import { GetUserDetails } from "../../Helpers/Utility";
import { getData } from "../../Services/Api";

export default function SubscribeModal({
  showSubscribe,
  handleSubscribeModalClose,
  subscribedPlan,
}) {
  const [subscribeData, setSubscribeData] = useState([]);
  const userDetails = useMemo(() => GetUserDetails(), []);

  const getUser = useCallback(async () => {
    if (userDetails) {
      const headers = {
        Authorization: `Bearer ${userDetails.token}`,
      };

      const response = await getData("subscription-history", headers);
      if (response.success === true) {
        setSubscribeData(response?.data?.subscriptionHistory);
      }
    }
  }, [userDetails]);

  useEffect(() => {
    if (showSubscribe) {
      getUser();
    }
  }, [showSubscribe, getUser]);

  return (
    <Modal
      show={showSubscribe}
      onHide={handleSubscribeModalClose}
      centered
      size="xl"
    >
      <Modal.Header closeButton className='px-4 d-flex align-items-baseline'>
        <div className='d-flex flex-column '>
          <Modal.Title className='text-uppercase fw-bold'>Subscription History 
          </Modal.Title>
          {/* <small className='text-black-50'>How to i get started lorem ipsum dolor at?</small> */}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="subscription-info px-2">
          <p className="plan-name text-success">{subscribedPlan?.name}</p>
        </div>
        <div className='table-responisve'>
        <table className="table px-3 border rounded-3">
          <thead>
            <tr>
              <th>S.no</th>
              <th>Date Subscribed</th>
              <th>Date Expired</th>
              <th>Data Subscribed</th>
              {/* <th>Data Remaining</th> */}
            </tr>
          </thead>
          <tbody>
            {subscribeData.map((data, index) => (
              <tr key={index}>
                {/* <td>{data.id}</td> */}
                <td>{data.index}</td>
                <td>{data.date_subscribe}</td>
                <td>{data.date_expired}</td>
                <td>{data.data_subscribed}</td>
                {/* <td>{data.data_remaining}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
</div>
      </Modal.Body>
    </Modal>
  );
}
